import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { campaignKeys, refreshOutreachKpisNow } from '@discovr/features';
import { moveToBrandSkipLabel, moveToBrandSummary } from './moveToBrandCopy';
import { OperationProgress } from './OperationProgress';

export interface MoveToBrandProgressProps {
  campaignId: string;
  operationId: string;
  onSettled: () => void;
}

export function MoveToBrandProgress({ campaignId, operationId, onSettled }: MoveToBrandProgressProps) {
  const queryClient = useQueryClient();
  const refresh = () => {
    queryClient.invalidateQueries({ queryKey: campaignKeys.outreachRowsAll(campaignId) });
    queryClient.invalidateQueries({ queryKey: campaignKeys.outreachCounts(campaignId) });
    void refreshOutreachKpisNow(queryClient, campaignId);
  };
  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <OperationProgress
        campaignId={campaignId}
        operationId={operationId}
        outcomeCopy={moveToBrandSkipLabel}
        onDone={(operation) => {
          onSettled();
          if (operation.appliedCount === 0) toast.error(moveToBrandSummary(operation));
          else toast.success(moveToBrandSummary(operation));
          refresh();
        }}
        onError={() => {
          onSettled();
          refresh();
          toast.error("Couldn't read this batch's progress. Try again.");
        }}
      />
    </div>
  );
}
